<div *ngFor="let notice of notices">
	<div *ngIf="notice != null" [@noticeState]="notice.state" [class]="notice.classes" [ngStyle]="notice.styles">
		<button
			type="button"
			class="close"
			(click)="dismiss(notice.id)"
			data-dismiss="alert" aria-label="Close">x</button>
		<span translate [innerHTML]="notice.message"> <b>{{notice.title | translate}}:</b></span>
	</div>
</div>